import { render, staticRenderFns } from "./ChildProductModal.vue?vue&type=template&id=6c664e6e&scoped=true"
import script from "./ChildProductModal.vue?vue&type=script&lang=js"
export * from "./ChildProductModal.vue?vue&type=script&lang=js"
import style0 from "./ChildProductModal.vue?vue&type=style&index=0&id=6c664e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c664e6e",
  null
  
)

export default component.exports